import type { EndpointDefinition } from "../../_sdk/types/common";

export const apiName = "workspaces";

export const endpoints: { [key: string]: EndpointDefinition } = {
    getUserPermissionsToResourceFolder: {
        route: "/workspaces/:workspaceId/permissions/folder/:resourceFolderId",
        method: "GET"
    },
    getUserPermissionsToResource: {
        route: "/workspaces/:workspaceId/permissions/resource/:resourceType/:resourceId",
        method: "GET"
    },
    getUserActionPermissions: {
        route: "/workspaces/:workspaceId/action-permissions",
        method: "GET"
    }
};
